'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { ROLLING_DURATION_MS } from './constants';
const ROLLING_INTERVAL_MS = 3000;

// 0부터 length까지 올라간다 — length는 트랙 끝에 복제된 1위 행이라 거기서 0으로 되돌린다.
export const useRollingStep = (length, isPaused) => {
  const $ = _c(8);
  const [step, setStep] = useState(0);
  let t0;
  let t1;
  if ($[0] !== isPaused || $[1] !== length) {
    t0 = () => {
      if (length < 2 || isPaused) {
        return;
      }
      const interval = setInterval(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
          return;
        }
        setStep(previousStep => previousStep >= length ? 1 : previousStep + 1);
      }, ROLLING_INTERVAL_MS);
      return () => clearInterval(interval);
    };
    t1 = [length, isPaused];
    $[0] = isPaused;
    $[1] = length;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[4] !== length || $[5] !== step) {
    t2 = () => {
      if (length < 2 || step !== length) {
        return;
      }
      const timer = setTimeout(() => setStep(0), ROLLING_DURATION_MS);
      return () => clearTimeout(timer);
    };
    t3 = [step, length];
    $[4] = length;
    $[5] = step;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  return Math.min(step, length);
};